import * as React from 'react';
import { Localize } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../../reducers';
import { TableCell, TableCellInner, TableCellInnerContent, Label, Email } from '../styles';
import ResourceIcon from '../ResourceIcon';
import { Api } from '../../../../typings/api';
import { openPreview } from '../../../../containers/ProposalStatsPage/actions';

interface RowProps {
	proposalStatus: Api.ProposalStatus;
	type: Api.AssetItemFileTypes;
	fileType: Api.AssetItemFileFormats;
	isProposal: boolean;
	label: string;
	recipientEmail: string;
	sendingDate: number;
	openingDate: number | null;
	readsNbr: number;
	relUrl: string;
	dispatch: Dispatch<StoreState>;
	downloads?: number;
}

const Row = ({
	proposalStatus,
	type,
	fileType,
	isProposal,
	label,
	recipientEmail,
	readsNbr,
	downloads,
	sendingDate,
	openingDate,
	relUrl,
	dispatch,
}: RowProps) => (
	<tr>
		<TableCell onClick={() => dispatch(openPreview(relUrl, type))}>
			<ResourceIcon
				type={type}
				fileFormat={fileType}
				isProposal={isProposal}
			/>
		</TableCell>
		<TableCell>
			<TableCellInner>
				<TableCellInnerContent>
					<Label>{label}</Label>
					<Email>{recipientEmail}</Email>
				</TableCellInnerContent>
			</TableCellInner>
		</TableCell>
		{proposalStatus === Api.ProposalStatus.SEEN &&
			<>
				<TableCell>{readsNbr}</TableCell>
				<TableCell>{downloads === undefined ? '-' : downloads}</TableCell>
			</>
		}
		<TableCell>
			<Localize value={sendingDate} dateFormat="date_format.digital_slash" />
		</TableCell>
		{openingDate &&
			<TableCell>
				<Localize value={openingDate} dateFormat="date_format.digital_slash" />
			</TableCell>
		}
	</tr>
);

export default Row;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProposalStatsPage/Table/Row/index.tsx